import _extends from "@babel/runtime/helpers/esm/extends";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import Modal from '../../Modal';
import LoadingIndicator from '../../LoadingIndicator';
import Button from '../../Button';
import Icon from '../../Icon';
import DropdownWithButton from '../DropdownWithButton/DropdownWithButton';
import { RestoreButton, RestoreButtonLabel } from './savedFilterModal.style';
function SavedFilterModal(_ref) {
  let {
    savedFilters,
    isLoading,
    onModalClose,
    onSavedFilterDelete,
    onApplySavedFilter
  } = _ref;
  const [selectedFilter, setSelectedFilter] = useState(savedFilters[0]);
  useEffect(() => {
    setSelectedFilter(savedFilters[0]);
  }, [savedFilters]);
  const handleFilterChange = selectedFilter => {
    setSelectedFilter(selectedFilter);
  };
  const handleDelete = () => {
    if (selectedFilter) {
      const {
        filter_title
      } = selectedFilter;
      onSavedFilterDelete(filter_title);
    }
  };
  const onClose = () => {
    onModalClose();
  };
  const onSave = () => {
    if (selectedFilter) {
      onApplySavedFilter(selectedFilter);
      onModalClose();
    }
  };
  return _jsx(Modal, _extends({
    heading: "Apply Saved Filter",
    open: true,
    zindex: 999999,
    showCloseIcon: true,
    onClose: onModalClose,
    dimension: "small",
    actions: {
      primaryAction: (savedFilters === null || savedFilters === void 0 ? void 0 : savedFilters.length) ? _jsx(Button, {
        label: "Apply",
        disabled: false,
        onClick: onSave
      }) : _jsx(_Fragment, {}),
      secondaryAction: (savedFilters === null || savedFilters === void 0 ? void 0 : savedFilters.length) ? _jsx(Button, {
        variant: "outlined",
        label: "Cancel",
        onClick: onClose
      }) : _jsx(_Fragment, {}),
      tertiaryAction: (savedFilters === null || savedFilters === void 0 ? void 0 : savedFilters.length) ? _jsxs(RestoreButton, _extends({
        onClick: handleDelete
      }, {
        children: [_jsx(Icon, {
          name: "trash",
          size: "20"
        }), _jsx(RestoreButtonLabel, {
          children: "Delete"
        })]
      })) : _jsx(_Fragment, {})
    }
  }, {
    children: _jsx("div", _extends({
      className: "saved-filters__modal__body"
    }, {
      children: isLoading ? _jsx(LoadingIndicator, {
        label: "Fetching applied filters...",
        variant: "bar"
      }) : (savedFilters === null || savedFilters === void 0 ? void 0 : savedFilters.length) ? _jsx("div", _extends({
        className: "saved-filters__modal__body__filters"
      }, {
        children: _jsx(DropdownWithButton, {
          id: "saved-filter",
          filterName: 'test',
          options: savedFilters,
          selectedFilter: selectedFilter,
          onChange: handleFilterChange,
          onDelete: handleDelete
        })
      })) : _jsx("p", {
        children: "No results found."
      })
    }))
  }));
}
export default SavedFilterModal;